import { variables } from '../mpanels/variables';

type Variables = typeof variables;

export const createMuiStepStyles = () => ({
    styleOverrides: {
        root: {
            color: '#FFFFFF',
            '& .Mui-active': {
                color: '#FFFFFF',
            },
        },
    },
});

export const createMuiStepIconStyles = (variables: Variables) => ({
    styleOverrides: {
        root: {
            color: variables.colors.other.text.lightGray,
            '&.Mui-active': {
                color: variables.colors.other.background.highlight,
                '> text': {
                    fill: variables.colors.palette.primary.main,
                },
            },
        },
        text: {
            fill: variables.colors.other.text.lightGray,
            fontWeight: 'bold',
            '&.Mui-active': {
                fill: variables.colors.palette.primary.main,
            },
        },
    },
});

export const createMuiStepLabelStyles = (variables: Variables) => ({
    styleOverrides: {
        root: {
            '.MuiStepLabel-iconContainer': {
                padding: '0',
            },
        },
        vertical: {
            '.MuiStepLabel-label': {
                display: 'inline-block',
                whiteSpace: 'nowrap',
                marginLeft: '8px',
                '&.Mui-active': {
                    display: 'inline-block',
                    fontWeight: 500,
                    color: variables.colors.palette.primary.main,
                },
            },
        },
        horizontal: {
            '.MuiStepLabel-label': {
                display: 'none',
                whiteSpace: 'wrap',
                marginLeft: '8px',
                '&.Mui-active': {
                    display: 'none',
                    fontWeight: 500,
                    color: variables.colors.palette.primary.main,
                },
            },
        },
    },
});

export const createMuiStepConnectorStyles = () => ({
    styleOverrides: {
        root: {
            fill: '#FFFFFF',
        },
    },
});
